import dynamic from 'next/dynamic';
import Layout from '../../components/common/Layout';
import { fetchDataCitiesForImmobilienPage } from '../../utils/page';

const PropertyView = dynamic(
  import('../../components/Properties/PropertyView'),
);
const SearchBox = dynamic(import('../../components/common/SearchBox'));

const PropertyListPage = (props) => (
  <div>
    <Layout title="Immobiliensuche - wohnpreis.de">
      <SearchBox />
      <PropertyView {...props} />
    </Layout>
  </div>
);

export async function getServerSideProps() {
  const requestData = {
    buyOrRent: 'rent',
    houseOrApartment: 'apartment',
    serverSide: true,
  };
  const options = await fetchDataCitiesForImmobilienPage(requestData);
  return {
    props: { options: options.length ? options : [] },
  };
}

export default PropertyListPage;
